import React, { lazy, Suspense, useState } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import HomeView from './pages/Home/HomeView';
import { ROUTES } from './routes';
import SideBar from './components/SideBar/SideBar';
import { DRAWER_WIDTH, DRAWER_COLLAPSED_WIDTH, DRAWER_COLLAPSED_MOBILE_WIDTH } from './components/SideBar/constants';
import { Layout } from './components/Layout/Layout';
import { Content } from './components/Layout/Content';
import { isMobileDevice } from './utils/helpers';

// Lazy load pages not needed on initial render — reduces JS heap on startup
const SessionsView = lazy(() => import('./pages/Sessions/SessionsView'));
const SettingsView = lazy(() => import('./pages/Settings/SettingsView'));

const App = () => {
  const { search } = useLocation();
  const [isSideBarOpen, setIsSideBarOpen] = useState(false);

  const toggleSideBar = () => setIsSideBarOpen(prev => !prev);
  const collapsedWidth = isMobileDevice() ? DRAWER_COLLAPSED_MOBILE_WIDTH : DRAWER_COLLAPSED_WIDTH;

  return (
    <Layout className={`layout-grid ${isSideBarOpen ? '' : 'collapsed'}`}>
      <SideBar collapsed={!isSideBarOpen} onClickMenu={toggleSideBar} />
      <Content className="content-column">
        <Suspense fallback={null}>
          <Routes>
            <Route path={ROUTES.tourPlanner} element={<HomeView sideBarWidth={isSideBarOpen ? DRAWER_WIDTH : collapsedWidth} />} />
            <Route path={ROUTES.sessions} element={<SessionsView />} />
            <Route path={ROUTES.settings} element={<SettingsView />} />
            <Route
              path="*"
              element={<Navigate to={{ pathname: ROUTES.tourPlanner, search }} replace />}
            />
          </Routes>
        </Suspense>
      </Content>
    </Layout>
  );
};

export default App;
